import React, { useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Avatar, Tooltip, Paper } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import styles from '../AgentActionGroups.styles';
import type { AgentActionGroup as AgentActionGroupType } from 'configuration-schemas/viewdefns/viewdefn';
import { AgentAction } from './AgentAction';

interface AgentActionGroupProps {
  group: AgentActionGroupType;
  groupIndex: number;
  scope: {
    productMember: string | null;
    locationMember: string | null;
  };
}

export const AgentActionGroup = ({ group, groupIndex, scope }: AgentActionGroupProps) => {
  const [selectedActionIndex, setSelectedActionIndex] = useState<number | null>(null);

  const handleActionClick = (actionIndex: number) => {
    setSelectedActionIndex(selectedActionIndex === actionIndex ? null : actionIndex);
  };

  return (
    <Accordion key={`${group.text}-${groupIndex}`} style={{ height: '100%' }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel${groupIndex}-content`}
        id={`panel${groupIndex}-header`}
      >
        <Tooltip title={group.actions.length} placement="top-start" arrow>
          <Avatar className={'action-avatar'} variant="square">
            <span>{group.actions.length > 99 ? '99+' : group.actions.length}</span>
          </Avatar>
        </Tooltip>
        <div className={styles.groupTextContainer}>
          <div className={styles.groupCategory}>{group.text}</div>
          <div className={styles.groupTitle}>{group.description}</div>
        </div>
      </AccordionSummary>
      <AccordionDetails style={{display: 'flex', flexDirection: 'column'}}>
          {group.actions.map((action, actionIndex) => (
            <AgentAction
              key={`${group.text}-${action.text}-${actionIndex}`}
              action={action}
              actionIndex={actionIndex}
              groupText={group.text}
              isSelected={selectedActionIndex === actionIndex}
              onActionClick={handleActionClick}
              scope={scope}
            />
          ))}
      </AccordionDetails>
    </Accordion>
  );
};
